// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-preview[data-v-73f1befa]{position:relative;margin:10px}.product-preview__img[data-v-73f1befa]{max-height:var(--value);max-width:var(--value)}.product-preview__img-shape[data-v-73f1befa]{position:absolute}", ""]);
// Exports
module.exports = exports;
